/* eslint-disable jira/naming/disallow-filenames */
import type BoardsDirectoryType from '@jira/spa-apps__directories-boards/src/BoardsDirectoryType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyBoardsDirectory: LazyComponent<(props: Record<any, any>) => React.JSX.Element> =
	lazyForPaint<typeof BoardsDirectoryType>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-boards-directory", jiraSpaEntry: "async-boards-directory" */ '@jira/spa-apps__directories-boards/src/BoardsDirectoryType.tsx'
			),
		),
	);
